/**
 * WordPress dependencies
 */
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

/**
 * Save function
 */

export default function save( props ) {
	// Block Props
	const blockProps = useBlockProps.save();
	const { children } = useInnerBlocksProps.save( blockProps );
	return children;
}
